import React, { useEffect, useRef, useState } from "react";
import { PulseLoader } from "react-spinners";
import {
  CheckIncheckOutCameraApi,
  GetCheckinCheckoutapi,
} from "../../../api/api";
import { SkeletonCard } from "../../../context/Customfunction";
import axios from "axios";
import { useSelector } from "react-redux";

function LiveCheckingCheckout() {
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState([]);
  const [cameras, setcameras] = useState([]);
  console.log("cameras", cameras);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const intervalRef = useRef(null);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  const fetchData = async (pageNo = 1, append = false) => {
    setLoading(true);
    try {
      const res = await GetCheckinCheckoutapi(selectedDate, "", pageNo, 10);
      if (res?.data?.status) {
        const newData = res.data.data;
        setEventData((prev) => (append ? [...prev, ...newData] : newData));
        setHasMore(newData.length === 10); // if less than limit, no more pages
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // intervalRef.current = setInterval(() => {
    setPage(1);
    fetchData(1, false);
    fetchCamera();
    // }, 15000);
    // return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    setPage(1);
    fetchData(1, false);
  }, [selectedDate]);

  const fetchCamera = async () => {
    try {
      const data = await CheckIncheckOutCameraApi(user_id, organization_id);
      console.log(data);
      if (data?.data?.status === true) {
        setcameras(data?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const cameraCards = [
    {
      label: "Checkin Camera",
      // image: "https://visionemptrack.greymatterz.com/stream/cam22",
      image:
        "https://visionemptrack.greymatterz.com/stream/check_in_685c00e1a178e25cf8560984",
    },
    {
      label: "Checkin Camera 1",
      image:
        "https://visionemptrack.greymatterz.com/stream/check_in_6888a734f347ddcea20b4a52",
    },
    {
      label: "Checkout Camera",
      // image: "https://visionemptrack.greymatterz.com/stream/cam27",
      image:
        "https://visionemptrack.greymatterz.com/stream/check_out_685c00a2a178e25cf8560983",
    },
    {
      label: "Checkout Camera 1",
      // image: "https://visionemptrack.greymatterz.com/stream/cam27",
      image:
        "https://visionemptrack.greymatterz.com/stream/check_out_68a5caffb647ecccf6091360",
    },

    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_in_685cf1069742046beaa9da7f",
    // },
    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_in_685cf0b09742046beaa9da7e",
    // },
    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_in_6894b2b03539bda757094dcf",
    // },
    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_in_6894b1a2dc9092ad9a4cd319",
    // },
    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_out_686fd3210541fce2ba3141f7",
    // },
    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_out_688097e03ac118e54d4042bc",
    // },
    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_out_685c00a2a178e25cf8560983",
    // },
    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_out_685c00e1a178e25cf8560984",
    // },
    // {
    //   label: "Checkout Camera",
    //   // image: "https://visionemptrack.greymatterz.com/stream/cam27",
    //   image:
    //     "https://visionemptrack.greymatterz.com/stream/check_out_685bff47a178e25cf8560981",
    // },
  ];

  const loadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchData(nextPage, true);
  };

  useEffect(() => {
    try {
      const interval = setInterval(() => {
        if (performance?.memory) {
          const used = (
            performance.memory.usedJSHeapSize /
            1024 /
            1024
          ).toFixed(2);
          console.log(`[Dev] JS Heap Used: ${used} MB`);
        }
      }, 5000); // log every 5 seconds

      return () => clearInterval(interval);
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <div className="d-flex fullHeightCst">
      {/* LEFT SECTION */}
      <div className="leftSection">
        <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
          <div className="col-xl-7">
            <h2 className="mb-0">Check-in / Check-out</h2>
          </div>
          <div className="col-xl-5">
            <div className="d-flex gap-2">
              <div
                className="d-flex flex-column mt-0"
                style={{ minWidth: "140px" }}
              >
                <input
                  id="dateFilter"
                  type="date"
                  className="form-control"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="p-4">
          {cameras &&
            cameras.map((group, groupIdx) => (
              <div key={groupIdx} className="mb-6">
                {/* Group title */}
                <h5 className="mb-3">{group.camera_group_name}</h5>

                <div className="cameraGrid" key={groupIdx}>
                  {group.cameras.map((cam, idx) => (
                    <div key={idx} className="image-box bg-white">
                      <img
                        src={cam.custom_url} // ✅ use custom_url instead of raw camera_url
                        alt={group.camera_group_name + " " + idx}
                        className="img-fluid"
                        // style={{
                        //   height: "200px",
                        //   objectFit: "cover",
                        //   width: "100%",
                        // }}
                      />
                      {/* Optional label */}
                      {/* <div className="text-center py-2">{group.camera_group_name} - Cam {idx+1}</div> */}
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="rightSection bg-white border-start">
        <div className="position-sticky top-0">
          <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
            <h2>Details</h2>
          </div>

          <div className="px-3 my-3 cstHeighRight">
            {loading ? (
              Array.from({ length: 5 }).map((_, i) => <SkeletonCard key={i} />)
            ) : (
              <table className="table cstTable table-sm mb-0">
                <thead className="sticky-top" style={{ top: 0, zIndex: 1 }}>
                  <tr>
                    <td>&nbsp;</td>
                    <td>Name</td>
                    <td>In</td>
                    <td>Out</td>
                  </tr>
                </thead>
                <tbody>
                  {eventData.map((user, idx) => (
                    <tr key={idx}>
                      <td>
                        <img
                          src={`https://visionemptrack.greymatterz.com/${user.image_dataset_path}`}
                          alt={user.name}
                          className="rounded-circle"
                          onClick={() =>
                            setZoomedImage(
                              `https://visionemptrack.greymatterz.com/${user.image_dataset_path}`
                            )
                          }
                          style={{
                            width: "75px",
                            height: "75px",
                            objectFit: "cover",
                            cursor: "zoom-in",
                          }}
                        />
                      </td>
                      <td>
                        <h3 className={user.isUnknown ? "text-danger" : ""}>
                          {user?.employee_name}
                        </h3>
                        <p className="mb-0">
                          {user.in_office === true ? "In Office" : "Out Office"}
                        </p>
                      </td>
                      <td className={user.isUnknown ? "text-danger" : ""}>
                        {user.in_time
                          ? new Date(user.in_time).toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "N/A"}
                      </td>
                      <td className={user.isUnknown ? "text-danger" : ""}>
                        {user.out_time
                          ? new Date(user.out_time).toLocaleTimeString(
                              "en-US",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              }
                            )
                          : "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {hasMore && !loading && (
              <div className="text-center my-3">
                <button className="btn btn-primary" onClick={loadMore}>
                  Load More
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {zoomedImage && (
        <div
          className="zoomed-image-overlay"
          onClick={() => setZoomedImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={zoomedImage}
            alt="Zoomed"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 20px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}
    </div>
  );
}

export default LiveCheckingCheckout;
